import ReactGA from "react-ga4";
import store from "../redux/store";
// const MEASUREMENT_ID = "G-FBQ9RKEBB4" // for local work use 
const MEASUREMENT_ID = process.env.REACT_GA_MEASUREMENT_ID || "G-Y0F0MNLCFE"
export const initGA = () => {
    ReactGA.initialize(MEASUREMENT_ID);
};
const getUserId = () => store.getState().user.currentUser?._id ?? null;
export const emailDomain = (value) =>
    [...new Set(String(value ?? "").split(/[\s,;]+/).map((email) => email.split("@")[1]?.toLowerCase()).filter(Boolean))].join(",") || null;
export const trackPageView = (path, moduleName) => {
    ReactGA.send({
        hitType: "pageview",
        page_path: path,
        module_name: moduleName,
        jk_user_id: getUserId()
    });
};
export const trackEvent = (
    eventName,
    module_name,
    page_path,
    parameters = {}
) => {
    ReactGA.event(eventName, {
        jk_user_id: getUserId(),
        page_path: page_path,
        module_name: module_name,
        ...parameters
    });
};
const SEARCH_EVENT_NAMES = [
    "clickSearchButton",
    "sysResultLoaded",
];
const SUCCESS_ERROR_NAMES = [
    "clickSaveChanges",
    "sysAddUserFailure",
    "sysAddUserSuccess",
    "clickEditChanges",
    "sysEditUserSuccess",
    "sysEditUserFailure",
    "clickDeleteChanges",
    "sysDeleteUserSuccess",
    "sysDeleteUserFailure",
    "sysAddRoleSuccess",
    "sysAddRoleFailure",
    "sysEditRoleSuccess",
    "sysEditRoleFailure",
    "sysAddEmailAlertSuccess",
    "sysAddEmailAlertFailure",
    "sysEditEmailAlertSuccess",
    "sysEditEmailAlertFailure",
    "sysDeleteEmailAlertSuccess",
    "sysDeleteEmailAlertFailure",
    "sysAddVehicleSuccess",
    "sysAddVehicleFailure",
    "sysEditVehicleSuccess",
    "sysEditVehicleFailure",
    "sysDeleteVehicleSuccess",
    "sysDeleteVehicleFailure",
    "sysAddDtpPlanningSuccess",
    "sysAddDtpPlanningFailure",
    "sysEditDtpPlanningSuccess",
    "sysEditDtpPlanningFailure",
    "sysDeleteDtpPlanningSuccess",
    "sysDeleteDtpPlanningFailure",
    "clickApproveButton",
    "sysApproveDtpPlanningSuccess",
    "sysApproveDtpPlanningFailure",
    "sysDeleteUploadCpkmSuccess",
    "sysDeleteUploadCpkmFailure",
    "sysBulkUploadCpkmSuccess",
    "sysBulkUploadCpkmFailure"
]
const DOWNLOAD_BTN_AND_BULK_UPLOAD_EVENTS = [
    "clickDownloadButton",
    "sysDownloadSuccess",
    "sysDownloadFailure",
    "clickBulkUploadButton",
    "sysBulkUploadVehicleSuccess",
    "sysBulkUploadVehicleFailure",
    "sysBulkUploadCpkmSuccess",
    "sysBulkUploadCpkmFailure",
]
const makeArray = (value) => {
    if (value === "All" || value === "all") {
        return "All"
    }
    if ( Array.isArray(value) && value !== null && value!== undefined){
        if(value?.length > 2){
            return [value[0],value[1],`...+${value?.length - 2} more`]
        }
        return value;
    }else if(value !== null && value !== undefined){
        return [value];
    }else{
        return []
    }
}
export const trackSearchEvent = (eventName, module_name, page_path, params = {}) => {
    if (!SEARCH_EVENT_NAMES.includes(eventName)) return;
    const eventParams = {
        filter_fleet_type: params.fleet_type ?? null,
        filter_fleets: makeArray(params.fleets || null),
        filter_contract_type: params.contract_type ?? null,
        filter_from_date: params.from_date ?? null,
        filter_to_date: params.to_date ?? null,
        filter_hubs: makeArray(params.hubs || null),
        filter_tyre_size: params.tyre_size ?? null,
        filter_configurations: makeArray(params.configurations || null),
        filter_percentage_wear: params.percentage_wear ?? null,
        filter_tyre_patterns: makeArray(params.tyre_patterns || null),
        filter_search_value: params.search_value ?? null,
        filter_agreement: params.agreement ?? null,
        filter_kam: makeArray(params.kam || null),
        filter_quarter: params.quarter ?? null,
        filter_status: params.status ?? null,
    };
    trackEvent(eventName, module_name, page_path, eventParams);
    return eventParams;
};
export const trackDownloadAndBulkUploadEvents = (eventName, module_name, page_path, params = {}) => {
    if(!DOWNLOAD_BTN_AND_BULK_UPLOAD_EVENTS.includes(eventName)) return;
    const eventParams = {
        model_name: params.model_name,
        errMsg: params.errMsg
    }
    trackEvent(eventName,module_name,page_path,eventParams)
}
export const saveErrorCreationEvent = (eventName,model_name, module_name, page_path, params = {}) => {
    if(!SUCCESS_ERROR_NAMES.includes(eventName)) return;
    const eventParams = {
        model_name: model_name || null,
        fleets: makeArray(params.fleets || null),
        hubs: makeArray(params.hubs || null),
        configurations: makeArray(params.configurations || null),
        permissions: makeArray(params.permissions || null), 
        kam: makeArray(params.kam || null)
    }
    const finalParams = { ...params, ...eventParams };
    trackEvent(eventName, module_name, page_path, finalParams);
}
const PAGE_CLICK_EVENTS = [
    "clickNextPageButton",
    "clickPreviousPageButton"
]
export const trackPageClickEvent = (eventName,module_name,page_path) => {
  if(!PAGE_CLICK_EVENTS.includes(eventName)) return;
 
  trackEvent(eventName,module_name,page_path);
}